/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Request body for updating coin information
 * @export
 * @interface UpdateCoinRequest
 */
export interface UpdateCoinRequest {
    /**
     * The description of the coin (max 2500 characters)
     * @type {string}
     * @memberof UpdateCoinRequest
     */
    description?: string;
    /**
     * URL for the coin's banner image
     * @type {string}
     * @memberof UpdateCoinRequest
     */
    bannerImageUrl?: string;
    /**
     * Generic link URL for the coin
     * @type {string}
     * @memberof UpdateCoinRequest
     */
    link1?: string;
    /**
     * Generic link URL for the coin
     * @type {string}
     * @memberof UpdateCoinRequest
     */
    link2?: string;
    /**
     * Generic link URL for the coin
     * @type {string}
     * @memberof UpdateCoinRequest
     */
    link3?: string;
    /**
     * Generic link URL for the coin
     * @type {string}
     * @memberof UpdateCoinRequest
     */
    link4?: string;
}

/**
 * Check if a given object implements the UpdateCoinRequest interface.
 */
export function instanceOfUpdateCoinRequest(value: object): value is UpdateCoinRequest {
    let isInstance = true;

    return isInstance;
}

export function UpdateCoinRequestFromJSON(json: any): UpdateCoinRequest {
    return UpdateCoinRequestFromJSONTyped(json, false);
}

export function UpdateCoinRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCoinRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'bannerImageUrl': !exists(json, 'banner_image_url') ? undefined : json['banner_image_url'],
        'link1': !exists(json, 'link_1') ? undefined : json['link_1'],
        'link2': !exists(json, 'link_2') ? undefined : json['link_2'],
        'link3': !exists(json, 'link_3') ? undefined : json['link_3'],
        'link4': !exists(json, 'link_4') ? undefined : json['link_4'],
    };
}

export function UpdateCoinRequestToJSON(value?: UpdateCoinRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'banner_image_url': value.bannerImageUrl,
        'link_1': value.link1,
        'link_2': value.link2,
        'link_3': value.link3,
        'link_4': value.link4,
    };
}

